import {environment} from 'src/environments/environment';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {mapParseItem} from '@brunata-angular/util';
import {interceptorSkipHeader} from '@shared/utils/errorInterceptor';
import {z} from 'zod';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private http = inject(HttpClient);

    getUser(): Observable<User> {
        return this.http
            .get(`${environment.onlineServiceUrl}/user`, {
                headers: new HttpHeaders().set(interceptorSkipHeader, ''),
            })
            .pipe(mapParseItem(userSchema));
    }

    updateUser(user: UserUpdate): Observable<User> {
        return this.http
            .put(`${environment.onlineServiceUrl}/user`, user)
            .pipe(mapParseItem(userSchema));
    }
}

const userSchema = z.object({
    fullName: z.string(),
    username: z.string(),
    language: z.string().nullable(),
    debtorNo: z.string().nullable(),
    buildingServices: z.array(z.number()),
    userType: z.string(),
    // 'ADMINISTRATOR' for the main account and admin sub-users, otherwise 'USER'
    // (derived backend-side from the customer account / sub-user adminrole).
    role: z.string(),
    email: z.string().nullable(),
});

export type User = z.infer<typeof userSchema>;

export type UserUpdate = {
    // Email cannot be set to null if it is already not null.
    email: string;
    // PersonName can only be changed if the user is a sub user.
    personName?: string;
    language: string | null;
};
